import { render, staticRenderFns } from "./compose-patient.vue?vue&type=template&id=ddd7af32&"
import script from "./compose-patient.vue?vue&type=script&lang=ts&"
export * from "./compose-patient.vue?vue&type=script&lang=ts&"
import style0 from "./compose-patient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports